module.exports = __webpack_public_path__ + "img/status_table.c5a20785.jpg";